import { differenceInHours } from 'date-fns';
import { GetDashboardAnalyticsParams } from './getDashboardAnalyticsParams';

export const addIntervalToDashboardAnalyticsTimeRange = (
  params: GetDashboardAnalyticsParams
): (GetDashboardAnalyticsParams & { interval?: number }) | undefined => {
  if (!params.from || !params.to) {
    return undefined;
  }

  const SIX_HOURS_DURATION = 6 * 60;
  const ONE_DAY_DURATION = 24 * 60;
  const SEVEN_DAYS_DURATION = 7 * ONE_DAY_DURATION;
  const MONTHLY_DURATION = 30 * ONE_DAY_DURATION;

  const durationInHours = differenceInHours(
    new Date(params.to),
    new Date(params.from)
  );

  if (durationInHours <= 24) {
    return { ...params, interval: 15 };
  } else if (durationInHours <= 24 * 7) {
    return { ...params, interval: SIX_HOURS_DURATION };
  } else if (durationInHours <= 24 * 31) {
    return { ...params, interval: ONE_DAY_DURATION };
  } else if (durationInHours <= 24 * 186) {
    return { ...params, interval: SEVEN_DAYS_DURATION };
  } else {
    return { ...params, interval: MONTHLY_DURATION };
  }
};
